import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { WorkTypeId } from 'services/workTypes/types';

// Local Selectors
import { makeSelectIsHarvestSchemaWorkType } from './selectors';

export interface OwnProps {
    workTypeId: WorkTypeId;
    children: React.ReactElement;
}

interface ConnectedProps {
    isHarvestSchemaWorkType: boolean;
}

type Props = OwnProps & ConnectedProps;

export class IsHarvestSchemaWorkTypeGateComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { isHarvestSchemaWorkType, children } = this.props;
        if (!isHarvestSchemaWorkType) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isHarvestSchemaWorkType: makeSelectIsHarvestSchemaWorkType()
});

export default connect(mapStateToProps)(IsHarvestSchemaWorkTypeGateComponent);
